module.exports = __webpack_public_path__ + "static/img/16-1.b7f2745.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/16-1.jpg
// module id = SDLl
// module chunks = 0